var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"x-button font-opensans",style:(`background-color: ${_vm.bgColor}; color: ${_vm.color}; font-weight: ${_vm.fontWeight}`),on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }